export default "__VITE_ASSET__C9jq1r_O__"